import React from 'react';
// import PropTypes from 'prop-types';

import {Stack, Typography, Box, Card, CardContent} from 'views/components';
import {Translate} from 'views/module';
import {Schedule, Favorite, People} from 'views/icons';

const WelcomeSection = () => {
  return (
    <Box
      sx={{py: 3, px: {lg: 18, md: 5, xs: 1}}}
    >
      <Stack spacing={4} alignItems="center">
        {/* Header Section */}
        <Box textAlign="center">
          <Box sx={{mb: 2}}>
            <img
              src="/logo/quilt-icon.png"
              alt="CareQuilt Logo"
              width="60"
              height="60"
              style={{display: 'block', margin: '0 auto'}}
            />
          </Box>
          <Typography variant="h3" component="h1" gutterBottom>
            <Translate expression="caregiverInterview.Landing.Title" />
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{maxWidth: 600}}>
            <Translate expression="caregiverInterview.Landing.Subtitle" />
          </Typography>
        </Box>

        {/* Benefits Cards */}
        <Stack
          direction={{xs: 'column', md: 'row'}}
          spacing={3}
          sx={{width: '100%', mt: 4}}
        >
          <Card sx={{flex: 1}}>
            <CardContent sx={{textAlign: 'center', p: 3}}>
              <Schedule sx={{fontSize: 40, color: 'primary.main', mb: 2}} />
              <Typography variant="h6" gutterBottom>
                <Translate expression="caregiverInterview.Landing.FlexibleWork" />
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <Translate expression="caregiverInterview.Landing.FlexibleWorkDesc" />
              </Typography>
            </CardContent>
          </Card>

          <Card sx={{flex: 1}}>
            <CardContent sx={{textAlign: 'center', p: 3}}>
              <Favorite sx={{fontSize: 40, color: 'primary.main', mb: 2}} />
              <Typography variant="h6" gutterBottom>
                <Translate expression="caregiverInterview.Landing.MeaningfulWork" />
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <Translate expression="caregiverInterview.Landing.MeaningfulWorkDesc" />
              </Typography>
            </CardContent>
          </Card>

          <Card sx={{flex: 1}}>
            <CardContent sx={{textAlign: 'center', p: 3}}>
              <People sx={{fontSize: 40, color: 'primary.main', mb: 2}} />
              <Typography variant="h6" gutterBottom>
                <Translate expression="caregiverInterview.Landing.Community" />
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <Translate expression="caregiverInterview.Landing.CommunityDesc" />
              </Typography>
            </CardContent>
          </Card>
        </Stack>

        {/* Application Process Overview */}
        <Box sx={{textAlign: 'center', mt: 4}}>
          <Typography variant="h5" gutterBottom>
            <Translate expression="caregiverInterview.Landing.ProcessTitle" />
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{mb: 1}}>
            <Translate expression="caregiverInterview.Landing.ProcessDesc" />
          </Typography>

          {/* Additional Info */}
          <Typography variant="body2" color="text.secondary" sx={{textAlign: 'center'}}>
            <Translate expression="caregiverInterview.Landing.TimeEstimate" />
          </Typography>
        </Box>

      </Stack>
    </Box>
  );
};

export default WelcomeSection;
